<div class="controls">
    <div class="button-group vertical">
        <button id="btn-hint">Hint</button>
        <button id="btn-next">Solve Next</button>
        <button id="btn-solve">Solve</button>
    </div>
    <div class="button-group vertical">
        <button id="btn-reset-to-valid">Reset to last valid state</button>
        <button id="btn-reset">Reset</button>
    </div>
    <div class="button-group horizontal">
        <button id="btn-undo">Undo</button>
        <button id="btn-redo">Redo</button>
    </div>
    <div class="button-group horizontal">
        <button id="btn-black" class="color-toggle checked"></button>
        <button id="btn-white" class="color-toggle"></button>
    </div>
</div>